import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ADMIN_GET_ACTIVE_PROJECTS, ADMIN_GET_ALL_PROJECTS, ADMIN_GET_PROJECT_COMPLETION_GRAPH, ADMIN_GET_PROJECT_CUSTOM_CARDS, ADMIN_GET_PROJECT_REVENUE, ADMIN_GET_PROJECT_SUBMISSION_STATUS, ADMIN_GET_PROJECT_UNIT_WISE, ADMIN_GET_PROJECT_UNIT_WISE_GRAPH, ADMIN_GET_PROJECT_WISE_SUMMARY, ADMIN_GET_PROJECT_YEAR_WISE_GRAPH, ADMIN_UPDATE_PROJECT_STATUS, ADMIN_UPDATE_PROJECT_MW, ADMIN_PROJECTS_BALANCE_REPORT, ADMIN_GET_MONITORING_PROJECT_FILLED_STATUS, ADMIN_GET_OTHER_PROJECT_FILLED_STATUS } from "../../api/endpoints";
import openNotification from "../../components/Common/OpenNotification";
import axiosInstance from "../../utils/axiosInstance";

const initialState = {
        projects: [],
        activeProjects: [],
        projectDataSubmissions: [],
        projectSummary: [],
        unitWiseProjects: [],
        totalProjects: 0,
        totalSubmissionData: 0,
        totalActiveProjects: 0,
        totalUnitWiseProjects: 0,
        customCards: {
                revenue: null,
                projectCost: null,
                profit_loss: null,
                apportionedCost: null,
                totalOperationalIncome: null,
                totalNetBilling: null,
                totalCashInflow: null,
                totalCashOutflow: null,
                netCashFlow: null,
                projectProfit: null,
                DM: null,
        },
        revenueDetails: {
                ALLOCATION: null,
                PVC: null,
                ERV: null,
                TCR: null,
                REVENUE_RECOGNISED_UPTO: null,
                IO_NO: null,
                OTHER_ADJUS: null,
                BALNACE_REVENUE: null,
                CURRENT_FACTOR: null,
                CCI_UPTO: null,
                TOTAL: null,
        },
        monitoringProjectStatus: [],
        otherProjectStatus: [],
        projectCompletionGraphDetails: {
                label: [],
                value: [],
                percentage: [],
                color: [],
                total: 0
        },
        unitWiseContributionDetails: {
                label: [],
                value: [],
                color: [],
                total: 0
        },
        yearWiseGraphDetails: {
                cashInFlow: [],
                cashOutFlow: [],
                label: [],
                projectCost: [],
                projectProfit: [],
        },
        balanceRevenue: {

                Labels: [],
                Projects: [],
                data: [],
        },
        loading: false,
        error: null,
};

const getRandomColor = () => {
        const COLORS = ['#D1671D', '#F8A138', '#FAE477', '#B5C153', '#708735', '#495D28', '#A6C76D', '#95BDF8', '#5360AE', '#B894D1', '#775498', '#613860', '#A25F8B', '#D86680', '#964059'];
        return COLORS;
};

export const fetchYearWiseGraph = createAsyncThunk('project/fetchYearWiseGraph', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_PROJECT_YEAR_WISE_GRAPH, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const fetchProjectBalanceRevenue = createAsyncThunk(
        "project/fetchBalanceRevenue",
        async (params = {}, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_PROJECTS_BALANCE_REPORT,
                                {
                                        params,
                                }
                        );

                        return response.data.data;
                } catch (error) {
                        openNotification(
                                error?.response?.data?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong."
                        );
                }
        }
);

export const fetchUnitWiseContributionGraph = createAsyncThunk('project/fetchUnitWiseContributionGraph', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_PROJECT_UNIT_WISE_GRAPH, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchProjectCompletionGraph = createAsyncThunk('projectCompletion/fetch', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_PROJECT_COMPLETION_GRAPH, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchUnitWiseProjects = createAsyncThunk('projectRevenue/fetchUnitWiseProjects', async (params, { rejectWithValue }) => {
        try {
                // Create a shallow copy and remove MNF_UNIT if it's an empty string
                const filteredParams = { ...params };
                if (filteredParams?.MNF_UNIT === '') {
                        delete filteredParams.MNF_UNIT;
                }
                if (filteredParams?.from_month === '') {
                        delete filteredParams.from_month;
                        delete filteredParams.from_year;
                }
                if (filteredParams?.to_month === '') {
                        delete filteredParams.to_month;
                        delete filteredParams.to_year;
                }
                const response = await axiosInstance.get(ADMIN_GET_PROJECT_UNIT_WISE, {
                        params: filteredParams,
                });

                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});


export const fetchProjectRevenue = createAsyncThunk('projectRevenue/fetch', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_PROJECT_REVENUE, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchProjectCustomCards = createAsyncThunk('project/fetchCustomCards', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_PROJECT_CUSTOM_CARDS, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchProjectWiseSummary = createAsyncThunk('project/fetchProjectWiseSummary', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_PROJECT_WISE_SUMMARY, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchProjectDataSubmissions = createAsyncThunk('project/fetchProjectDataSubmissions', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_PROJECT_SUBMISSION_STATUS, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const fetchMonitoringProjectDataFilledStatus = createAsyncThunk('project/fetchMonitoringProjectDataFilledStatus', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_MONITORING_PROJECT_FILLED_STATUS, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const fetchOtherProjectDataFilledStatus = createAsyncThunk('project/fetchOtherProjectDataFilledStatus', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_OTHER_PROJECT_FILLED_STATUS, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchProjects = createAsyncThunk('project/fetchAllProjects', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_ALL_PROJECTS, {
                        params,
                });
                return response.data.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const updateProjectStatus = createAsyncThunk('project/updateActive', async ({ IO_NO, REV_NO, IS_MONITORING, IS_ACTIVE, IS_CLEAR, PROJECT_TYPE }, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(ADMIN_UPDATE_PROJECT_STATUS, { IO_NO, REV_NO, IS_MONITORING, IS_ACTIVE, IS_CLEAR, PROJECT_TYPE });
                return { IO_NO, IS_MONITORING, IS_ACTIVE, IS_CLEAR, PROJECT_TYPE };
        } catch (err) {
                openNotification(err?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue({
                        error: err.response?.data || err.message,
                        prevStatus: {
                                IO_NO,
                                IS_ACTIVE: !IS_ACTIVE,
                                IS_MONITORING: !IS_MONITORING,
                                IS_CLEAR: !IS_CLEAR,
                                PROJECT_TYPE,
                        },
                });
        }
});

export const updateProjectMW = createAsyncThunk('project/updateProjectMW', async ({ IO_NO, REV_NO, MW }, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(ADMIN_UPDATE_PROJECT_MW, { IO_NO, REV_NO, MW });
                openNotification('success', 'Updated', response?.data?.message || 'Project MW updated successfully.');
                return { IO_NO, REV_NO, MW };
        } catch (err) {
                openNotification('error', 'Update Failed', err?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(err?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchActiveProjects = createAsyncThunk('project/fetchActiveProjects', async (params = {}, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(ADMIN_GET_ACTIVE_PROJECTS, {
                        params,
                });
                return response.data.data;
        } catch (err) {
                return rejectWithValue(err.response?.data || err.message);
        }
});

const projectSlice = createSlice({
        name: 'project',
        initialState,
        reducers: {},
        extraReducers: (builder) => {
                builder.addCase(fetchProjects.pending, (state) => {
                        state.loading = true;
                        state.error = null;
                })
                        .addCase(fetchProjects.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projects = action.payload.data;
                                state.totalProjects = action.payload.totalRecords;
                        })
                        .addCase(fetchProjects.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchProjectDataSubmissions.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchProjectDataSubmissions.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectDataSubmissions = action.payload.data;
                                state.totalSubmissionData = action.payload.pagination.total;
                        })
                        .addCase(fetchProjectDataSubmissions.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchMonitoringProjectDataFilledStatus.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchMonitoringProjectDataFilledStatus.fulfilled, (state, action) => {
                                state.loading = false;
                                state.monitoringProjectStatus = action.payload.data;
                                state.totalMonitoringSubmissionData = action.payload.pagination?.totalCount;

                                // state.totalFilledData = action.payload.pagination.total;
                        })
                        .addCase(fetchMonitoringProjectDataFilledStatus.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchOtherProjectDataFilledStatus.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchOtherProjectDataFilledStatus.fulfilled, (state, action) => {
                                state.loading = false;
                                state.otherProjectStatus = action.payload.data;
                                state.totalOtherProjectData = action.payload.pagination?.totalCount;
                        })
                        .addCase(fetchOtherProjectDataFilledStatus.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchProjectWiseSummary.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchProjectWiseSummary.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectSummary = action.payload;
                        })
                        .addCase(fetchProjectWiseSummary.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(updateProjectStatus.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(updateProjectStatus.fulfilled, (state, action) => {
                                state.loading = false;
                                const { IO_NO, IS_ACTIVE, IS_MONITORING, IS_CLEAR } = action.payload;
                                const index = state.projects.findIndex((item) => item.IO_NO === IO_NO);
                                if (index !== -1) {
                                        state.projects[index].IS_ACTIVE = IS_ACTIVE;
                                        state.projects[index].IS_MONITORING = IS_MONITORING;
                                        state.projects[index].IS_CLEAR = IS_CLEAR;
                                }
                        })
                        .addCase(updateProjectStatus.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload?.error;
                                const prev = action.payload?.prevStatus;
                                if (prev) {
                                        const index = state.projects.findIndex((item) => item.IO_NO === prev.IO_NO);
                                        if (index !== -1) {
                                                state.projects[index].IS_ACTIVE = prev.IS_ACTIVE;
                                                state.projects[index].IS_MONITORING = prev.IS_MONITORING;
                                                state.projects[index].IS_CLEAR = prev.IS_CLEAR;
                                        }
                                }
                        })
                        .addCase(updateProjectMW.fulfilled, (state, action) => {
                                const { IO_NO, REV_NO, MW } = action.payload;
                                const index = state.projects.findIndex((item) => item.IO_NO === IO_NO && item.REV_NO === REV_NO);
                                if (index !== -1) {
                                        state.projects[index].MW = MW === '' ? null : MW;
                                }
                        })
                        .addCase(fetchUnitWiseProjects.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchUnitWiseProjects.fulfilled, (state, action) => {
                                state.loading = false;
                                state.unitWiseProjects = action.payload.data;
                                state.totalUnitWiseProjects = action.payload.total;
                        })
                        .addCase(fetchUnitWiseProjects.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchActiveProjects.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchActiveProjects.fulfilled, (state, action) => {
                                state.loading = false;
                                state.activeProjects = action.payload.data;
                                state.totalActiveProjects = action.payload.total;
                        })
                        .addCase(fetchActiveProjects.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchProjectCustomCards.pending, (state) => {
                                state.customLoading = true;
                                state.error = null;
                        })
                        .addCase(fetchProjectCustomCards.fulfilled, (state, action) => {
                                state.customLoading = false;
                                console.log('action.payload', action.payload);
                                state.customCards = action.payload;
                        })
                        .addCase(fetchProjectCustomCards.rejected, (state, action) => {
                                state.customLoading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchProjectRevenue.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchProjectRevenue.fulfilled, (state, action) => {
                                state.loading = false;
                                state.revenueDetails = action.payload;
                        })
                        .addCase(fetchProjectRevenue.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchProjectCompletionGraph.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchProjectCompletionGraph.fulfilled, (state, action) => {
                                state.loading = false;
                                const rawItem = {
                                        label: [],
                                        value: [],
                                        percentage: [],
                                        color: [],
                                };
                                action.payload.data.forEach((item) => {
                                        rawItem.label.push(item.label);
                                        rawItem.value.push(parseFloat(item.value.replace(/,/g, '')) || 0);
                                        rawItem.percentage.push(item.percentage);
                                        rawItem.color = [...getRandomColor()];
                                });
                                state.projectCompletionGraphDetails = { ...rawItem, total: action.payload.total };
                        })
                        .addCase(fetchProjectCompletionGraph.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchUnitWiseContributionGraph.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchUnitWiseContributionGraph.fulfilled, (state, action) => {
                                state.loading = false;
                                const rawItem = {
                                        label: [],
                                        value: [],
                                        color: [],
                                };
                                action.payload.rows.forEach((item) => {
                                        rawItem.label.push(item?.UNIT_NAME);
                                        rawItem.value.push(parseFloat(item?.REVENUE?.replace(/,/g, '')) || 0);
                                        rawItem.color = [...getRandomColor()];
                                });
                                state.unitWiseContributionDetails = {
                                        ...rawItem,
                                        total: action?.payload?.total,
                                };
                        })
                        .addCase(fetchUnitWiseContributionGraph.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchYearWiseGraph.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchYearWiseGraph.fulfilled, (state, action) => {
                                state.loading = false;
                                const rawItem = {
                                        label: [],
                                        cashInFlow: [],
                                        cashOutFlow: [],
                                        projectCost: [],
                                        projectProfit: [],
                                };
                                // action.payload.forEach((item) => {
                                //         rawItem?.label.push(item.YEAR);
                                //         rawItem?.cashInFlow.push(parseFloat(item?.CASH_INFLOW?.replace(/,/g, '')) || 0);
                                //         rawItem?.cashOutFlow.push(parseFloat(item?.CASH_OUTFLOW?.replace(/,/g, '')) || 0);
                                //         rawItem?.projectCost.push(parseFloat(item?.PROJECT_COST?.replace(/,/g, '')) || 0);
                                //         rawItem?.projectProfit.push(parseFloat(item?.PROJECT_PROFIT?.replace(/,/g, '')) || 0);
                                // });

                                action.payload.forEach((item) => {
                                        // rawItem.label.push(item.YEAR);
                                        rawItem.label.push(item.financial_year);

                                        rawItem.cashInFlow.push(
                                                parseFloat(item?.cash_inflow?.replace(/,/g, "")) || 0
                                        );

                                        rawItem.cashOutFlow.push(
                                                parseFloat(item?.cash_outflow?.replace(/,/g, "")) || 0
                                        );

                                        rawItem.projectCost.push(
                                                parseFloat(item?.project_cost?.replace(/,/g, "")) || 0
                                        );

                                        rawItem.projectProfit.push(
                                                parseFloat(item?.project_profit?.replace(/,/g, "")) || 0
                                        );
                                });
                                state.yearWiseGraphDetails = rawItem;
                        })
                        .addCase(fetchYearWiseGraph.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchProjectBalanceRevenue.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchProjectBalanceRevenue.fulfilled, (state, action) => {
                                state.loading = false;
                                const rawItem = {
                                        Labels: [],
                                        Projects: [],
                                        data: [],

                                };

                                rawItem.Labels.push(action.payload.Labels);
                                rawItem.Projects.push(action.payload.Projects);
                                rawItem.data.push(action.payload.data);

                                state.balanceRevenue = rawItem;
                        })
                        .addCase(fetchProjectBalanceRevenue.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        });
        },
});

export default projectSlice.reducer;
